import Vue from 'vue';
import VueRouter from 'vue-router';

import { Auth } from 'aws-amplify';
import MainView from '@/components/MainView.vue';
import GraphView from '@/components/GraphView.vue';
import StatusView from '@/components/StatusView.vue';
import UserManagementView from '../components/UserManagementView.vue';
import TndAccountAdministration from '../components/TndAccountAdministration.vue';
import NotSignedInView from '@/components/NotSignedInView.vue';
import CheckoutView from '@/components/CheckoutView.vue';
import AverageTemperatureView from '@/components/AverageTemperatureView.vue';

import { determineUserRole } from '@/determine-user-role';

import { text } from '@/language';
import { peek } from '@/tools';

peek; // lint

Vue.use(VueRouter);

function computeRoutes() {
    const routes = [
        {
            path: text( 'graphViewPath', 'es' ),
            alias : ['/', text( 'graphViewPath', 'en' ) ],
            name: text( 'graphViewName' ),
            component: GraphView,
            meta: {
                requiresAuth : true,
            },
        },
        {
            path: text( 'tableViewPath', 'es' ),
            alias: text( 'tableViewPath', 'en' ),
            name: text( 'tableViewName' ),
            component: MainView,
            meta: {
                requiresAuth : true,
            },
        },
        {
            path: text( 'statusViewPath', 'es' ),
            alias: text( 'statusViewPath', 'en' ),
            name: text( 'statusViewName' ),
            component: StatusView,
            meta: {
                requiresAuth : true,
            },
        },
        {
            path: text( 'checkoutViewPath', 'es' ),
            alias : text( 'checkoutViewPath', 'en' ),
            name: text( 'checkoutViewName' ),
            component: CheckoutView,
            meta: {
                requiresAuth : true,
            },
        },
        {
            path : text( 'averageTemperatureViewPath', 'es' ),
            alias : text( 'averageTemperatureViewPath', 'en' ),
            name : text( 'averageTemperatureViewName' ),
            component : AverageTemperatureView,
            meta: {
                requiresAuth : true,
            },
        },
        {
            path: text( 'usersViewPath', 'es' ),
            alias: text( 'usersViewPath', 'en' ),
            name: text( 'usersViewName' ),
            component: UserManagementView,
            meta: {
                requiresAuth : true,
                requiresSuperUser : true,
            },
        },
        {
            path: text( 'adminViewPath', 'es' ),
            alias: text( 'adminViewPath', 'en' ),
            name: text( 'adminViewName' ),
            component: TndAccountAdministration,
            meta: {
                requiresAuth : true,
                requiresSuperUser : true,
            },
        },
        {
            path: text( 'signInViewPath', 'es' ),
            alias: text( 'signInViewPath', 'en' ),
            name: text( 'signInViewName' ),
            meta: {
                requiresAuth : false,
            },
        }
    ];

    return routes;
}

if ( NotSignedInView == null )
    console.log();

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: computeRoutes(),
});

router.beforeResolve( async ( to, from, next ) => {
    const isSignedIn = await Auth.currentAuthenticatedUser().then( () => true ).catch( () => false );

    if ( to.matched.some( record => record.meta.requiresAuth ) ) {
        if ( ! isSignedIn ) {
            next( { path : text( 'signInViewName' ) } );
            return;
        }
    }

    const { isSuperUser, isCheckoutUser } = await determineUserRole();
    const checkoutViewName = text( 'checkoutViewName' ),
          statusViewName = text( 'statusViewName' );

    // console.log( `User is signed in? ${isSignedIn}, is admin? ${isAdminUser}, is checkout user ${checkoutUser}` );
    // console.log( `User wants to go to ${to.name}, ${to.path}` );

    if ( to.matched.some( record => record.meta.requiresSuperUser ) ) {
        if ( isSuperUser )
            next();
        else
            next( { path : '/' } );
    }
    else if ( ! to.matched.some( record => record.meta.requiresAuth ) ) {
        // console.log( 'No authentication needed, all good' );
        next();
    }
    else if ( isCheckoutUser && ! [checkoutViewName, statusViewName].includes( to.name ) ) {
        // console.log( `Redirecting checkout user to ${checkoutViewName}` );
        next( { name : checkoutViewName } );
    }
    else {
        // console.log( 'All good, allowing user to continue' );
        next();
    }
} );


export default router;

